/**
 * Created by zoechodosh on 2/17/17.
 */
import * as ActionTypes from '../actions/types/UserActionTypes';

const initialState = {
  busy: false,
  userContext: {},
  hasIdentified: false
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_USER: {
      return Object.assign({}, state, { busy: true });
    }
    case ActionTypes.RECEIVE_USER: {
      return Object.assign({}, state, { busy: false, userContext: action.payload });
    }
    case ActionTypes.IDENTIFY_USER: {
      return Object.assign({}, state, { hasIdentified: true });
    }
    default: return state;
  }
};

export default userReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/user.js
 **/